import Purchase from '@/pages/Purchase'

export default {
  path: '/purchase',
  name: 'purchase',
  component: Purchase
}



// WEBPACK FOOTER //
// ./src/router/purchase.js